import { useLocation, useNavigate } from "@aviv-unified-frontend/runtime/router";
export const useCdpNavigate = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const navigateWithParams = (route) => {
        navigate(`${route}${location.search}`);
    };
    return navigateWithParams;
};
